import { render, staticRenderFns } from "./ChefAlbum.vue?vue&type=template&id=da2a902e&"
import script from "./ChefAlbum.vue?vue&type=script&lang=js&"
export * from "./ChefAlbum.vue?vue&type=script&lang=js&"
import style0 from "./ChefAlbum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports